import React from 'react';

import AgDateFilterLayout from './AgDateFilterLayout';
import useAgDateFilterCore from './hooks/useAgDateFilterCore';
import { AgDateFilterProps } from './types';

const AgDateFilterFE: React.FC<AgDateFilterProps> = ({
  defaultOption,
  model,
  onModelChange,
  format,
  buttons,
  colDef,
  filterValueTransform,
}) => {
  const core = useAgDateFilterCore({
    defaultOption,
    model,
    onModelChange,
    field: colDef.field,
    isBEGrid: false,
    filterValueTransform,
  });

  return <AgDateFilterLayout format={format} buttons={buttons} {...core} />;
};

export default AgDateFilterFE;
